import { SanityImg } from "../../../../../lib/images.jsx";
import { blockContentStyles as styles } from "../../blockContent.css.js";

/**
 * ImageBlock is a React functional component used to render an image using the provided asset data and optional descriptive details.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.value - Contains the properties required for rendering the image.
 *
 * @returns {JSX.Element} A rendered image component or a fallback message when no asset is provided.
 */
const ImageBlock = ({ value }) => {
  const { decorative, description, position, image, asset } = value;

  const calcAsset = image?.asset ?? asset; // Handle legacy images
  if (!calcAsset) return <p className={styles.error}>No image uploaded</p>;

  const calcPos = position ? position : "center";

  return (
    <SanityImg
      width={1000}
      asset={calcAsset}
      className={styles.img({ position: calcPos })}
      decorative={decorative}
      alt={description}
    />
  );
};

export default ImageBlock;
